import React, { useEffect, useState } from "react";
import { Loader, SelectPicker } from "rsuite";

import { IQuoteUploadStatusPayload } from "../../services/interfaces/IQuoteUpload";
import {
  formatDateToLong,
  formatMonthShortYear,
} from "../../utils/helpers/mapModulesToIcon";
import { UploadQuoteLabels as LABELS } from "./UploadQuoteConstants";
import {
  useExecuteAssessment,
  useQuoteUploadFilters,
  useQuoteUploadStatus,
} from "../../react-query/hooks/HQuoteUpload";
import { useAppSelector } from "../../services/redux/hooks/hooks";

import VendorQuote from "./vendor-quote";
import AdditionalInputs from "./additional-inputs";
import { trackTabClick } from "../../utils/helpers/trackingEvent";
import { useLocation } from "react-router-dom";
import { sortCommodityFirst, getDefaultCommodity } from "../../utils/helpers/commodityOrder";

const UploadQuote = () => {
  const location = useLocation();
  const hiddenParam = location.state?.hiddenParam;
  const [commodity, setCommodity] = useState<string>();
  const [navItem, setNavItem] = useState<string>(
    hiddenParam === undefined || hiddenParam === "" ? "" : hiddenParam,
  );
  const [disableQuote, setDisableQuoteUpload] = useState<boolean>(false);
  const [isAssessmentExecuting, setAssessmentExecuting] = useState(false);
  // const [negWeek, setNegoWeek] = useState<any>("");

  const [quoteUploadStatusPayload, setQuoteUploadStatusPayload] =
    useState<IQuoteUploadStatusPayload>();

  const { filters, isLoading } = useQuoteUploadFilters(
    localStorage.getItem("userEmail"),
  );
  const { statusData, isStatusLoading } = useQuoteUploadStatus(
    quoteUploadStatusPayload,
  );

  const negotiationMonthText = formatMonthShortYear(filters?.date);
  const negotiationWeekText = filters?.date_wire
    ? formatDateToLong(filters?.date_wire)
    : "";
  const hasNegotiationHeader =
    commodity === "Copper Wire"
      ? Boolean(negotiationWeekText || negotiationMonthText)
      : Boolean(negotiationMonthText);

  const screenStatus = useAppSelector((state) => {
    return state.disableScreens;
  });

  const handleTabonClick = (tabName: string, tabLabel: string) => {
    setNavItem(tabName);
    trackTabClick(tabLabel, "Upload Quote");
  };
  useEffect(() => {
    // if (!screenStatus.quoteUpload) {
    //   setNavItem(
    //     hiddenParam === undefined || hiddenParam === ""
    //       ? "additionalInputs"
    //       : hiddenParam
    //   );
    //   setDisableQuoteUpload(true);
    // } else {
    setNavItem(
      hiddenParam === undefined || hiddenParam === ""
        ? "vendorQuote"
        : hiddenParam,
    );
    setDisableQuoteUpload(false);
    // }
  }, [screenStatus]);

  useEffect(() => {
    if (
      filters &&
      filters?.commodities?.length > 0 &&
      commodity === undefined
    ) {
      setCommodity(getDefaultCommodity(filters.commodities));
    }
  }, [filters]);

  // const handleNegWeek = (value: any) => {
  //   setNegoWeek(value);
  // };

  return (
    <>
      {isLoading || isStatusLoading || isAssessmentExecuting ? (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.6 }}
        />
      ) : (
        <div className="flex flex-col justify-stretch items-stretch h-full business-cost-settings">
          <div className="grow shrink-0 basis-[20%] ps-[3%] pr-[5%] pt-[1.6%] flex flex-col flex-nowrap justify-start items-start gap-0 shadow-normal relative">
            <div className="flex justify-between items-center w-full">
              <div className="font-normal text-[2vw]">{LABELS.quoteUpload}</div>
              <div className="flex justify-start items-center gap-8">
                <div className="flex flex-col justify-start items-start">
                  <label className="font-bold text-[0.8vw]">
                    {LABELS.commodityFilterName}
                  </label>
                  <SelectPicker
                    menuAutoWidth={true}
                    style={{
                      width: "10vw",
                      maxWidth: "10vw",
                      minWidth: "10vw",
                    }}
                    value={
                      commodity ||
                      (filters?.commodities &&
                        filters?.commodities?.length !== 0 &&
                        getDefaultCommodity(filters?.commodities)) ||
                      undefined
                    }
                    data={(() => {
                      const base = filters?.commodities || [];
                      const hasCopperWire = base.some(
                        (item: any) => item[LABELS.commodityKey] === "Copper Wire",
                      );
                      return sortCommodityFirst(
                        hasCopperWire
                          ? base
                          : [
                            ...base,
                            {
                              [LABELS.commodityKey]: "Copper Wire",
                            },
                          ],
                      );
                    })()}
                    labelKey={LABELS.commodityKey}
                    valueKey={LABELS.commodityKey}
                    onChange={(value: string | null) => {
                      value && setCommodity(value);
                    }}
                    placeholder="All"
                    cleanable={false}
                  ></SelectPicker>
                </div>
              </div>
            </div>
            {hasNegotiationHeader && (
              <>
                <span className="font-bold text-fs16 text-[#858585] ml-[0.25vh]">
                  {commodity === "Copper Wire"
                    ? LABELS.negotiationWeek
                    : LABELS.negotiationMonth}
                  &nbsp;
                  <span className="font-bold underline text-deloitteGreen">
                    {commodity === "Copper Wire"
                      ? negotiationWeekText
                      : negotiationMonthText}
                  </span>
                </span>
                {commodity === "Copper Wire" && (
                  <span className="font-bold text-fs16 text-[#858585] ml-[0.25vh] block pt-[0.5vh]">
                    {LABELS.negotiationMonth}
                    &nbsp;
                    <span className="font-bold underline text-deloitteGreen">
                      {negotiationMonthText}
                    </span>
                  </span>
                )}
              </>
            )}
            <div className="absolute bottom-0 flex justify-start items-center gap-6 text-black font-normal text-[1.8vh]">
              <span
                className={
                  (navItem === "vendorQuote"
                    ? `font-bold border-b-2 border-black ${disableQuote
                      ? "text-gray-400 cursor-not-allowed"
                      : "cursor-pointer"
                    }`
                    : `${disableQuote
                      ? "text-gray-400 cursor-not-allowed"
                      : "cursor-pointer"
                    }`) + " pb-[1vh]"
                }
                onClick={() => {
                  if (disableQuote) return;
                  handleTabonClick("vendorQuote", "Vendor Quote");
                }}
              >
                Supplier Quote
              </span>
              <span
                className={
                  (navItem === "additionalInputs"
                    ? "font-bold border-b-2 border-black"
                    : "") + " cursor-pointer pb-[1vh]"
                }
                onClick={() =>
                  handleTabonClick("additionalInputs", "Additional Inputs")
                }
              >
                Additional Inputs
              </span>
            </div>
          </div>

          {navItem === "vendorQuote" ? (
            <VendorQuote
              statusData={statusData}
              quoteUploadStatusPayload={quoteUploadStatusPayload}
              setQuoteUploadStatusPayload={setQuoteUploadStatusPayload}
              filters={filters}
              commodity={commodity}
              setAssessmentExecuting={setAssessmentExecuting}
              screenStatus={!!screenStatus.windowFlag as unknown as boolean}
            // setNegoWeek={handleNegWeek}
            />
          ) : (
            <AdditionalInputs
              data={[]}
              screenStatus={!!screenStatus.windowFlag as unknown as boolean}
              filters={filters}
              commodity={commodity}
            />
          )}
        </div>
      )}
    </>
  );
};

export default UploadQuote;
